<template>
  <div class="p-2">
    <svg
      width="16.5"
      height="23"
      viewBox="0 0 28 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="w-full h-full"
    >
      <path
        d="M7.62112 13.8162C6.77394 12.8061 6.26074 11.5027 6.26074 10.0853C6.26074 6.87581 8.8593 4.2854 12.0607 4.2854C15.262 4.2854 17.8606 6.88396 17.8606 10.0853C17.8606 11.6901 17.2089 13.14 16.1581 14.1909"
        stroke="#0D9488"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M0.990234 22.2065C2.7742 20.504 4.69664 21.1801 6.4806 22.8907L9.92634 25.5789V10.3867C9.92634 7.12834 13.9993 7.12834 13.9993 10.3867V18.6141C13.9993 17.4085 15.1805 16.431 16.4431 16.431C17.7057 16.431 18.8869 17.4085 18.8869 18.6141V20.3166C18.8869 19.111 19.3838 18.1335 20.6464 18.1335C21.909 18.1335 22.9599 19.111 22.9599 20.3166V22.3613C22.9599 21.1557 23.6767 20.1781 24.9393 20.1781C26.2019 20.1781 27.0002 21.1557 27.0002 22.3613L25.534 29.9696C25.534 29.9696 23.7337 37.92 17.1925 37.92C12.0524 37.92 9.1036 33.5782 9.1036 33.5782L0.990234 22.2065Z"
        stroke="#0D9488"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M13.9995 17.7181V20.9765"
        stroke="#0D9488"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M18.8867 20.1619V21.7911"
        stroke="#0D9488"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path d="M22.96 21.7911V23.4203" stroke="#0D9488" stroke-width="1.5" stroke-miterlimit="10" />
      <path
        d="M3.73535 14.3049C3.09182 13.0341 2.7334 11.6085 2.7334 10.0853C2.7334 4.92887 6.91227 0.75 12.0687 0.75C17.225 0.75 21.4039 4.92887 21.4039 10.0853C21.4039 11.8041 20.9396 13.4169 20.1331 14.7936"
        stroke="#0D9488"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </svg>
  </div>
</template>
